import * as React from 'react';

export const GreenCheck = () => {
    return (
        <svg role='img' width='1em' height='1em' viewBox='0 0 24 24' aria-label='No issues'>
            <path d='M18 6a12 12 0 1 0 12 12A11.95 11.95 0 0 0 18 6zm6.267 8.933l-7.333 8a1.289 1.289 0 0 1-1.867 0l-3.333-3.6a1.323 1.323 0 1 1 2-1.733L16 20.133l6.4-6.933a1.428 1.428 0 0 1 1.867-.133 1.287 1.287 0 0 1 0 1.866z' transform='translate(-6 -6)'/>
        </svg>
    );
};
